import { ApiError } from '../api/client.js'

interface ConflictRetryOpts {
  /** Re-fetch fresh data and return the new ETag. */
  reloadEtag: () => Promise<string>
  maxRetries?: number
}

/**
 * Wrap an API call that uses If-Match. On conflict/precondition_failed,
 * silently reload the ETag and retry once.
 */
export async function withConflictRetry<T>(
  action: (etag: string) => Promise<T>,
  currentEtag: string,
  opts: ConflictRetryOpts,
): Promise<T> {
  const maxRetries = opts.maxRetries ?? 1
  let etag = currentEtag
  for (let attempt = 0; ; attempt++) {
    try {
      return await action(etag)
    } catch (err) {
      const isConflict =
        err instanceof ApiError && (err.code === 'conflict' || err.code === 'precondition_failed')
      if (!isConflict || attempt >= maxRetries) throw err
      etag = await opts.reloadEtag()
    }
  }
}
